import type {
  GetDashboardMlsShareRequestsQuery,
  GetDashboardMlsShareRequestsQueryVariables,
} from '@graphql/__generated__/graphql';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { DashboardMlsShareRequestsCardItem } from '@modules/dashboard/dashboard-mls-share-requests/DashboardMlsShareRequestsCardItem';
import { GET_DASHBOARD_MLS_SHARE_REQUESTS } from '@modules/dashboard/dashboardQueries';
import { useDashboardList } from '@modules/dashboard/hooks/useDashboardList';
import { DashboardCard } from '@modules/dashboard/shared/DashboardCard';
import { useLocale } from '@shared/hooks/locale';

export const DashboardMlsShareRequestsCard = () => {
  const { t } = useLocale();
  const { me } = useAppData();

  const queryResult = useDashboardList<
    GetDashboardMlsShareRequestsQuery,
    GetDashboardMlsShareRequestsQueryVariables,
    GetDashboardMlsShareRequestsQuery['mls_shares'][number]
  >({
    query: GET_DASHBOARD_MLS_SHARE_REQUESTS,
    variables: {
      where: {
        lot: { broker_id: { _eq: me?.id } },
        status: { _eq: 'pending' },
      },
    },
    dataKey: 'mls_shares',
    countKey: 'mls_shares_aggregate',
    fetchPolicy: 'network-only',
  });

  return (
    <DashboardCard
      title={t('MLS share requests')}
      queryResult={queryResult}
      renderItem={(request, key) => (
        <DashboardMlsShareRequestsCardItem
          key={key}
          request={request}
          onStatusChange={() => queryResult.refetch()}
        />
      )}
      emptyStateMessage={t('No pending share requests')}
      emptyStateVariant="success"
      hideBadge
    />
  );
};
